import React, { useEffect, useState } from 'react';
import { Topbar } from './Topbar';
import { SidebarNav, MobileNavDrawer, AdminBottomBar, CleanerBottomBar } from './SidebarNav';
import { useAuth } from '@/lib/auth';

const BASE_TITLE = 'FlexiClean — Cleaning & Turnover Ops';

// The page heading is already rendered as an <h1> by every page, so `title` drives
// the browser tab instead of being repeated in the topbar.
function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · FlexiClean` : BASE_TITLE;
    return () => { document.title = BASE_TITLE; };
  }, [title]);
}

export function AdminShell({ children, title }) {
  useDocumentTitle(title);
  // Owned here because two triggers open the same drawer: the topbar hamburger
  // and the "More" tab in the bottom bar.
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <SidebarNav />
      <MobileNavDrawer open={navOpen} onOpenChange={setNavOpen} />
      <div className="lg:pl-[264px]">
        <Topbar onOpenNav={() => setNavOpen(true)} />
        {/* pb-24 clears the fixed bottom bar on phones. */}
        <main className="px-4 md:px-6 lg:px-8 py-6 pb-24 lg:pb-10 max-w-[1440px] mx-auto">
          {children}
        </main>
      </div>
      <AdminBottomBar onMore={() => setNavOpen(true)} />
    </div>
  );
}

export function CleanerShell({ children, title }) {
  useDocumentTitle(title);
  return (
    <div className="min-h-screen bg-background pb-24">
      <Topbar />
      <main className="px-4 md:px-6 py-4">{children}</main>
      <CleanerBottomBar />
    </div>
  );
}

export function AppShell({ children, title }) {
  const { user } = useAuth();
  if (user?.role === 'cleaner') return <CleanerShell title={title}>{children}</CleanerShell>;
  return <AdminShell title={title}>{children}</AdminShell>;
}
